import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import TagManager from 'react-gtm-module';
import App from './App';
import './config/axiosClient';
import { GlobalStyles, theme } from '@bpba/ui-components';

if (process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY) {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY });
}

if (window.location.pathname === '/') {
  window.location.replace('/prestamoaca' + window.location.search + window.location.hash);
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
